module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.extra.isDirectDeal && this.id) ? _c('content-block', {
    attrs: {
      "title": "产品编号"
    }
  }, [_vm._v("\n        " + _vm._s(this.id) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.extra.isDirectDeal) ? _c('content-block', {
    attrs: {
      "title": "商家产品编号",
      "isRequired": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-8",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.partnerDealId')
    },
    attrs: {
      "type": "text",
      "name": "partnerDealId",
      "placeholder": "请填写商家产品编号",
      "disabled": !_vm.extra.isNew
    },
    model: {
      value: (_vm.model.partnerDealId),
      callback: function($$v) {
        _vm.model.partnerDealId = $$v
      },
      expression: "model.partnerDealId"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.partnerDealId')),
      expression: "validateErrors.has('tab1', 'model.partnerDealId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请填写商家产品编号")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.extra.isNew) ? _c('span', [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 产品保存后无法修改，请在上单前与商家确认")]) : _c('span', [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 商家产品编号在产品保存后不可更改")])])]) : _vm._e(), _vm._v(" "), (_vm.extra.isBD) ? _c('content-block', {
    attrs: {
      "title": "对应合同"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.extra.contractNum) + "\n    ")]) : _c('content-block', {
    attrs: {
      "title": "对应合同",
      "isRequired": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-select', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    staticClass: "col-sm-4",
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.contractId')
    },
    attrs: {
      "placeholder": "请选择合同"
    },
    model: {
      value: (_vm.model.contractId),
      callback: function($$v) {
        _vm.model.contractId = $$v
      },
      expression: "model.contractId"
    }
  }, _vm._l((_vm.contractsList), function(item) {
    return _c('v-option', {
      key: item.id,
      attrs: {
        "label": item.contractName,
        "value": item.id
      }
    })
  })), _vm._v(" "), (_vm.bankInfo && _vm.bankInfo.length > 0) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm.bankInfo))]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.contractId')),
      expression: "validateErrors.has('tab1','model.contractId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请选择合同")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcd8560c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/dealAndContract.vue
// module id = 534
// module chunks = 0